module.exports = __webpack_public_path__ + "img/icon-rueckgaberecht-schwarz.6ea540b7.svg";